window.DealTypes ?= {}

DealTypes.Model = Backbone.Model.extend
  urlRoot: ->
    @get('rootUrl')

  url: ->
    "#{@urlRoot()}/proxy/v2/consumers/#{@get('consumerId')}/feedback"

  toJSON: ->
    _csrf: @get 'csrf'
    deal_types: [
      id: @get 'id'
      value: @get 'value'
    ]

  isNew: ->
    true

  toggle: ->
    if @get('value') == 'positive'
      @set 'value', 'neutral'
    else
      @set 'value', 'positive'


module.exports = DealTypes.Model
